import { ErrorHandler, Injectable, Injector, Inject, forwardRef, NgZone } from '@angular/core';
import { LoggerService } from '../services/logger.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarAlertComponent } from '../snack-bar-alert/snack-bar-alert.component';
import { AlertData } from '../interfaces/alert-data';
import { AlertType } from '../enums/alert-type';
import { Message } from '../localization/message';
import { Exception } from '../core/exception';
import { SessionStorageService } from './storage.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector,
    @Inject(forwardRef(() => NgZone))
    private zone: NgZone
  ) {
    this.loggerService = this.injector.get(LoggerService);
    this.sessionStorageService = this.injector.get(SessionStorageService);
    this.snackBar = this.injector.get(MatSnackBar);
  }

  handleError(exception) {
    const self = this;
    // in case of promise error
    if (!!exception.rejection) {
      exception = exception.rejection;
    }

    if (!!exception && !!exception.data && !!exception.data.errorCode) {
      // User flow Exceptions
    }
    else {
      self.loggerService.error(exception);
    }


    const data: AlertData = {
      alertType: AlertType.Error,
      text: self.isTest && exception instanceof Exception ? exception.message : Message.GenericErrorMessage,
      code: exception instanceof Exception ? exception.code : null,
      url: self.url,
      title: "Message",
      isTest: self.isTest
    }
    this.zone.run(() => {
      self.snackBar.openFromComponent(SnackBarAlertComponent, { data: data });
    });
  }

  get url(): string {
    return this.isTest ? this.sessionStorageService.get("sc.landing-url") : "";
  }

  get isTest(): boolean {
    return this.sessionStorageService.get("sc.is-test");
  }

  private snackBar: MatSnackBar;
  private loggerService: LoggerService;
  private sessionStorageService: SessionStorageService;
}
